// src/flow/mediaFingerprint.js
// What a piece of media was built from, so we can tell when the text moved on.
const clean = (s) => String(s || "").replace(/\s+/g, " ").trim();

// An image uses the hook; an infographic also uses the body.
export const imageFingerprint = (segments, format) =>
  format === "infographic"
    ? `${clean(segments?.hook)}||${clean(segments?.cuerpo)}`
    : clean(segments?.hook);

// A carousel uses every text block.
export const carouselFingerprint = (segments) =>
  [segments?.hook, segments?.cuerpo, segments?.cta, (segments?.hashtags || []).join(" ")]
    .map(clean)
    .join("||");